import { apiSlice } from '../../app/api/apiSlice';

export const reviewsApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    lookupReviewer: builder.query({
      // `t` is the signed-link token and is preferred; `email` is the fallback
      // for forwarded links. Only one is ever sent — a token link deliberately
      // keeps the address out of the URL.
      query: ({ token, email } = {}) => {
        const params = new URLSearchParams();
        if (token) {
          params.append('t', token);
        } else if (email) {
          params.append('email', email);
        }

        return {
          url: `/reviews/lookup?${params.toString()}`,
          method: 'GET',
        };
      },
      transformResponse: (response) => response?.data,
    }),
    submitReview: builder.mutation({
      query: (payload) => ({
        url: '/reviews',
        method: 'POST',
        body: { ...payload },
      }),
      transformResponse: (response) => response?.data,
    }),
  }),
});

export const { useLazyLookupReviewerQuery, useSubmitReviewMutation } = reviewsApiSlice;
